import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Row } from 'react-bootstrap';
import Card from '../Card/Card';

// 1. Dynamically import all 39 images (Webpack require.context)
// If using Vite, replace with: const imagesMap = import.meta.glob('../../assets/testJedan/*.png', { eager: true });
const importAll = (r) => r.keys().sort((a, b) => {
  const numA = parseInt(a.replace(/[^0-9]/g, ''), 10);
  const numB = parseInt(b.replace(/[^0-9]/g, ''), 10);
  return numA - numB;
}).map(r);

const images = importAll(require.context('../../assets/testJedan', false, /\.png$/));

// Reusable inline styles
const styles = {
  div1: { display: "flex", justifyContent: "center", alignItems: "center", height: "inherit", padding: "3px" },
  div2: { width: "80%", height: "80%", background: "#fff", boxShadow: "15px 15px 25px #ccc", borderRadius: "15px" },
  centerText: { display: 'flex', alignItems: 'center', justifyContent: 'center' }
};

const TOTAL_QUESTIONS = 39;
const OPTIONS_PER_QUESTION = [1, 2, 3, 4];

const IntTestOne = ({ auth, history }) => {
  const [answers, setAnswers] = useState({});
  const [timeLeft, setTimeLeft] = useState({ minutes: 4, seconds: 3 });

  // Helper function to submit data to API
  const submitResults = useCallback(async (alertTitle) => {
    // Generate object with default empty strings for unanswered questions (P1..P39)
    const payload = Array.from({ length: TOTAL_QUESTIONS }).reduce((acc, _, index) => {
      const key = `P${index + 1}`;
      acc[key] = answers[key] || '';
      return acc;
    }, {});

    try {
      const resp = await axios.post('/api/intApi/saveTestIResult', payload);
      await Swal.fire(alertTitle, resp.data.message, resp.data.sign);
      history.push('/introIntTest');
    } catch (err) {
      console.error('Error submitting test:', err);
    }
  }, [answers, history]);

  // Initial check on mount
  useEffect(() => {
    axios.post('/api/intApi/checkIfTestIsAccessed/', { whatTest: 'intI' })
      .then(resp => {
        if (resp.data.message === true) {
          Swal.fire('Problem', 'Test je već rađen sa ovog naloga!', 'error');
          history.push('/introIntTest');
        }
      })
      .catch(console.error);
  }, [history]);

  // Timer Countdown Effect
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          submitResults('Niste na vreme završili test, ali su rezultati poslati!');
          return prev;
        }
        if (prev.seconds === 0) {
          return { minutes: prev.minutes - 1, seconds: 59 };
        }
        return { ...prev, seconds: prev.seconds - 1 };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [submitResults]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAnswers(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    Swal.fire({
      title: 'Da li sigurno želiš da predaš test?',
      text: "Nećeš moći da ga radiš ponovo",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Ček da proverim',
      confirmButtonText: 'Predaj!'
    }).then((result) => {
      if (result.isConfirmed) {
        submitResults('Poslato!');
      }
    });
  };

  return (
    <div className="Content">
      <div style={{ position: 'fixed', zIndex: 10 }}>
        <Card content={<Row>Vreme: {timeLeft.minutes}:{timeLeft.seconds < 10 ? `0${timeLeft.seconds}` : timeLeft.seconds}</Row>} />
      </div>

      <div style={styles.div1}>
        <div style={styles.div2}>
          <div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
            <div style={{ padding: "16px 0", textAlign: "left" }}>
              <br /><br />
              <div style={styles.centerText}>
                Zdravo {auth?.user?.name}, pred tobom je prvi deo testa sposobnosti, srećno!
              </div>
              <br /><br />

              {/* Dynamic rendering of 39 questions */}
              {Array.from({ length: TOTAL_QUESTIONS }).map((_, index) => {
                const qNum = index + 1;
                const name = `P${qNum}`;

                return (
                  <React.Fragment key={name}>
                    <div style={styles.centerText}>
                      <img style={{ width: '100%' }} alt={`Question ${qNum}`} src={images[index]} />
                    </div>
                    <div style={styles.centerText}>
                      <table style={{ width: '596px' }}>
                        <tbody>
                          <tr>
                            <td style={{ width: '140px' }}></td>
                            {OPTIONS_PER_QUESTION.map((val) => (
                              <td key={val} style={{ width: '115px', textAlign: 'center' }}>
                                <div className="form-check">
                                  <label style={{ fontSize: '15px' }}>
                                    <input
                                      onChange={handleChange}
                                      type="radio"
                                      name={name}
                                      value={val}
                                      checked={answers[name] === String(val)}
                                      className="form-check-input"
                                    /> {val}
                                  </label>
                                </div>
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br />
                  </React.Fragment>
                );
              })}

              <div style={styles.centerText}>
                <button type="button" onClick={handleSubmit} className="btn btn-primary mt-3">
                  Predaj test
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect()(IntTestOne);